import { render, staticRenderFns } from "./ConfiguracionesForm.vue?vue&type=template&id=d5df3c86"
import script from "./ConfiguracionesForm.vue?vue&type=script&lang=js"
export * from "./ConfiguracionesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports